/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-console */
import React, {
  useEffect,
  useImperativeHandle,
  forwardRef,
  useState,
  useRef,
} from 'react';
import { connect } from 'react-redux';
import action from '@flux/action';
import { deepCopy } from '@utils/common.js';
import { isNumber } from '@utils/currency.js';
import { Form, Select, Checkbox, Input, Table, message } from 'antd';
import { EditTableByRow } from '@components';

import debounce from 'lodash/debounce';
// import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
import {
  COMMON_SERVICE_ERROR,
  oldProjectRoleNames,
  projectRole,
  projectRoleOptions,
  projectRoleOptionForNonUs,
} from '@model';
import alert from '@components/alert';
import SelectPwcUserFormItem from '@components/selectPwcUser/SelectPwcUserFormItem';

import { tableColumns } from './teamForm.data.jsx';
import BulkAddUsersModal from '../projectSetting/components/BulkAddUsersModal';
import BulkAddUsersButton from '../projectSetting/components/BulkAddUsersButton';
import '../projectSetting/components/BulkAddUsersModal.scss';
import { getBulkAddSuccessMessage } from '../projectSetting/utils/bulkAddUsers.ui';

const { Option } = Select;

const CustomRoleSelect = ({
  index,
  customProps,
  uniqueRole,
  setUniqueRole,
}) => {
  const { roleField, currentRole, customRoleChange } = customProps;
  const [dropDownOpen, toggleDropDownOpen] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [customValue, setCustomValue] = useState();

  const debouncedToggleDropdown = debounce((v) => {
    toggleDropDownOpen(v);
  }, 100);

  const openDropDown = () => {
    debouncedToggleDropdown(true);
  };

  const closeDropDown = () => {
    debouncedToggleDropdown(false);
  };

  const handleSelectClick = (e) => {
    if (
      !e.target.className.includes('ant-select-item') &&
      !e.target.className.includes('custom-input')
    ) {
      if (dropDownOpen) {
        setShowInput(false);
        setCustomValue(null);
        closeDropDown();
      } else {
        openDropDown();
      }
    }
  };

  const handleSelect = (value) => {
    if (uniqueRole.lead === index && value != oldProjectRoleNames[0]) {
      setUniqueRole({
        ...uniqueRole,
        lead: null,
      });
    } else if (uniqueRole.lead != index && value === oldProjectRoleNames[0]) {
      setUniqueRole({
        ...uniqueRole,
        lead: index,
      });
    }
    if (uniqueRole.manager === index && value != oldProjectRoleNames[1]) {
      setUniqueRole({
        ...uniqueRole,
        manager: null,
      });
    } else if (
      uniqueRole.manager != index &&
      value === oldProjectRoleNames[1]
    ) {
      setUniqueRole({
        ...uniqueRole,
        manager: index,
      });
    }
    if (value && value === currentRole) {
      setShowInput(false);
      setCustomValue(null);
      closeDropDown();
      return;
    }
    if (value === 'Custom Role') {
      if (showInput === false) {
        setShowInput(true);
      }
      return;
    }
    if (showInput && !oldProjectRoleNames.includes(value)) {
      return;
    }
    setShowInput(false);
    setCustomValue(null);
    customRoleChange(value, index);
    closeDropDown();
  };

  const handlePressEnter = () => {
    setShowInput(false);
    setCustomValue(null);
    customRoleChange(customValue, index);
    closeDropDown();
  };

  const checkRole = (role) => {
    if (
      role === oldProjectRoleNames[0] &&
      uniqueRole.lead != null &&
      uniqueRole.lead != index
    ) {
      return true;
    }

    if (
      role === oldProjectRoleNames[1] &&
      uniqueRole.manager != null &&
      uniqueRole.manager != index
    ) {
      return true;
    }
    return false;
  };

  return (
    <Select
      open={dropDownOpen}
      style={{ position: 'absolute' }}
      dropdownClassName="role-custom-select-dropdown"
      defaultActiveFirstOption={false}
      value={currentRole}
      onClick={handleSelectClick}
      onSelect={handleSelect}
      onBlur={() => {
        if (showInput) {
          return;
        }
        setCustomValue(null);
        closeDropDown();
      }}
    >
      {roleField.map((i) => (
        <Option
          value={i}
          key={i}
          disabled={checkRole(i)}
          className={i === 'Custom Role' ? 'custom-role-style' : ''}
        >
          {i}
        </Option>
      ))}
      {showInput && (
        <Option key="input">
          <div className="custome-role-div">
            <Input
              autoFocus
              className="custom-input"
              maxLength={50}
              value={customValue}
              onClick={(e) => e.target.focus()}
              onChange={(e) => setCustomValue(e.target.value)}
              onPressEnter={handlePressEnter}
              onBlur={() => {
                setCustomValue(null);
                closeDropDown();
              }}
            />
            <div
              className="appkiticon icon-check-mark-fill a-font-18"
              onClick={handlePressEnter}
            />
          </div>
        </Option>
      )}
    </Select>
  );
};

const TeamForm = (props, ref) => {
  const {
    teamsData,
    groupData,
    getGroupData,
    groupManip,
    queryNamesResult,
    saveTeamsNames,
    memberData,
    renderAction,
    changeTeamsNames,
    createStep = false,
    setMemberOrClientChange = () => {},
  } = props;

  const [disabled, setDisabled] = useState([]);
  const [init, setInit] = useState(true);
  const history = useHistory();
  const isSettingPage = history.location.pathname.includes('setting');
  const [form] = Form.useForm();
  const [isInit, setIsInit] = useState(true);
  const [uniqueRole, setUniqueRole] = useState({
    lead: null,
    manager: null,
  });
  // 编辑行信息-当不为null的时候显示编辑行
  const [editInfo, setEditInfo] = useState(null);
  const [bulkAddVisible, setBulkAddVisible] = useState(false);

  const layout = {
    labelCol: { span: 6 },
    // wrapperCol: { span: 18 },
    labelAlign: 'left',
    colon: false,
  };

  const validateMember = (members) => {
    const res = [...new Set(members)].filter((member) => member?.email);
    const teamMemberArr = form.getFieldsValue().teamMember || [];
    const oldErrors = form
      .getFieldsError()
      .filter((i) => i.errors.length && i.name?.includes('email'));
    let teamErrors = [];
    const errorText = 'At least one member should be added in Team!';
    if (teamMemberArr.length) {
      teamErrors = teamMemberArr.map((item, index) => {
        const existError = oldErrors.find((i) => i.name?.[1] === index);
        return {
          name: ['teamMember', index, 'email'],
          errors: existError ? existError.errors : [errorText],
        };
      });
    }

    if (res.length === 0) {
      form.setFields([...teamErrors]);
      return false;
    }
    teamErrors = teamMemberArr.map((item, index) => ({
      name: ['teamMember', `${index}`],
      errors: [],
    }));
    form.setFields([...teamErrors]);
    return true;
  };

  const CuzCheckbox = ({ i }) => (
    <div className="eu-wrapper">
      <Checkbox
        onChange={(e) => {
          handleCheckbox(e, i);
        }}
        defaultChecked={memberData[i]?.isEUBased || false}
        className={`${disabled[i] ? 'eu-disabled' : ''}`}
      />
    </div>
  );
  useEffect(() => {
    if (init && memberData.length !== 0) {
      const disabledArr = memberData?.map((item) => {
        if (item) {
          return false;
        }
        return true;
      });
      setInit(false);
      setDisabled(disabledArr);
    }

    const res = [...new Set(memberData)].filter((member) => member?.email);
    const teamMemberArr = form.getFieldsValue().teamMember || [];
    let teamErrors = [];

    if (res.length) {
      teamErrors = teamMemberArr.map((item, index) => ({
        name: ['teamMember', `${index}`],
        errors: [],
      }));
      form.setFields([
        // {
        //   name: ['engagementLead'],
        //   errors: [],
        // },
        // {
        //   name: ['engagementManager'],
        //   errors: [],
        // },
        ...teamErrors,
      ]);
    }
  }, [memberData]);

  const uniqueRoleUpdated = useRef(false);
  useEffect(() => {
    if (
      !uniqueRoleUpdated.current &&
      memberData.length &&
      uniqueRole.lead === null &&
      uniqueRole.manager === null
    ) {
      const leadIndex = memberData.findIndex(
        (i) => i?.role_name === oldProjectRoleNames[0],
      );
      const manageIndex = memberData.findIndex(
        (i) => i?.role_name === oldProjectRoleNames[1],
      );
      if (leadIndex !== -1) {
        uniqueRole.lead = leadIndex;
      }
      if (manageIndex !== -1) {
        uniqueRole.manager = manageIndex;
      }
      uniqueRoleUpdated.current = true;
    }
  }, [memberData]);

  // 处理role那边禁用
  const handleUniqueRole = (index) => {
    if (Number(index) === uniqueRole.lead) {
      setUniqueRole({ ...uniqueRole, lead: null });
    } else if (Number(index) === uniqueRole.manager) {
      setUniqueRole({ ...uniqueRole, manager: null });
    }
  };

  const handleRemove = (remove, name, index) => () => {
    handleUniqueRole(index);

    remove(name);
    const data = deepCopy(queryNamesResult);
    const members = deepCopy(memberData);
    if (!createStep) {
      groupManip.deleteTeamMember({ ...members[index] });
    }

    data.splice(index, 1);
    members.splice(index, 1);
    setDisabled((pre) => {
      pre.splice(index, 1);
      return pre;
    });
    // changeTeamsNames({ data });
    saveTeamsNames({ data, memberData: members });
    form.setFieldsValue({ teamMember: members });
    setMemberOrClientChange('edit');
  };

  let fromRemove;
  const cancelEditing = () => {
    // 新增的需要把他移除
    if (editInfo?.isNew) {
      handleRemove(fromRemove, editInfo.name, editInfo.index)();
      // 隐藏掉编辑行
      setEditInfo(null);
    } else if (isNumber(editInfo?.index)) {
      console.log('editInfo: ', editInfo, memberData, form.getFieldsValue());
      handleUniqueRole(editInfo.index);
      // 恢复原先的默认值
      const members = deepCopy(memberData);
      members[editInfo.index] = editInfo;
      saveTeamsNames({ data: queryNamesResult, memberData: members });

      if (!createStep) {
        groupManip.updateTeamMember({ ...members[editInfo.index] });
      }

      // 隐藏掉编辑行
      setEditInfo(null);
    }
  };
  useImperativeHandle(props.cref, () => ({
    validateForm: (p) => {
      // TODO: swap sequence of following two kinds of validation
      const hasValidNumber = validateMember(p);
      if (!hasValidNumber) {
        return Promise.reject();
      }
      return new Promise(function (resolve, reject) {
        form
          .validateFields()
          .then(
            (res) => resolve(res),
            (err) => reject(err),
          )
          .catch((err) => {
            reject(err);
          });
      });
    },
    getForm: () => form,
    cancelEditing,
    getEditInfo: () => editInfo,
  }));

  useEffect(() => {
    const memberItem = {
      permission: projectRole.Contributor,
    };
    if (JSON.stringify(teamsData) !== '{}') {
      form.setFieldsValue(teamsData);
    } else {
      form.setFieldsValue({ teamMember: new Array(1).fill(memberItem) });
    }
  }, []);

  const getNewEditInfo = (data, index) => ({
    ...data,
    index,
    fieldKey: index,
    name: index,
    key: index,
    email: '',
    isEUBased: null,
    role_name: '',
    permission: projectRole['View-Only'],
  });

  const handleAdd = () => {
    const newItem = getNewEditInfo({ isNew: true }, memberData.length);
    const members = deepCopy(memberData);
    members[members.length] = newItem;
    saveTeamsNames({ data: queryNamesResult, memberData: members });
    setEditInfo(newItem);
    return newItem;
  };

  const handleCheckbox = (e, i) => {
    const members = deepCopy(memberData);
    const v = e.target.checked;
    if (!members[i]) {
      return;
    }
    members[i].isEUBased = v;
    saveTeamsNames({ data: queryNamesResult, memberData: members });
  };

  const checkUserDuplicate = (user, index) => {
    // 如果是编辑，且变的这个user跟改的user一致就不做duplicate验证
    if (!editInfo?.isNew && user.email === editInfo?.email) {
      return true;
    }
    const existUser = memberData.find((i = {}) => i.guid === user.guid);
    if (existUser) {
      alert.error({
        content: COMMON_SERVICE_ERROR.DUPLICATE,
      });
      const formValues = form.getFieldsValue();
      if (formValues.teamMember[index]) {
        formValues.teamMember[index] = {
          email: '',
          guid: null,
          permission: formValues.teamMember[index]?.permission,
          role_name: formValues.teamMember[index]?.role_name,
        };
        form.setFieldsValue({ ...formValues });
      }
    }
    return !existUser;
  };

  const handleChange = (
    user,
    index,
    keepEmail = null,
    validateAfterChange = false,
  ) => {
    let shouldUpdateUser = true;
    if (user && !checkUserDuplicate(user, index)) {
      user = null;
      shouldUpdateUser = false;
    }
    const value = user?.guid;

    const members = deepCopy(memberData);
    if (!createStep) {
      groupManip.deleteTeamMember({ ...members[index] });
    }
    const defaultPermission =
      index > 2 ? projectRole['View-Only'] : projectRole.Contributor;
    const permission = members[index]?.permission || defaultPermission;
    members[index] = user
      ? Object.assign(user, {
          permission: user.nonUS ? projectRole['View-Only'] : permission,
          isLead: String(index) === '0',
          isManager: String(index) === '1',
        })
      : {
          permission,
          role_name: members[index]?.role_name,
          email: keepEmail,
        };
    if (!value) {
      const queryResult = deepCopy(queryNamesResult);
      queryResult.splice(index, 1);
      setDisabled((pre) => {
        pre[index] = true;
        return pre;
      });
      changeTeamsNames({ data: queryResult });
      return false;
    }
    setDisabled((pre) => {
      pre[index] = false;
      return pre;
    });

    // 如果是新增的时候才去改，要不然编辑的时候改会导致无法cancel，触发在加一个状态
    // 新增的时候改是去为了table里面把这个隐藏掉
    if (editInfo?.isNew) {
      setEditInfo({ ...editInfo, ...members[index] });
    }
    saveTeamsNames({ data: queryNamesResult, memberData: members });
    form.setFieldsValue({ teamMember: members });
    if (!createStep) {
      groupManip.updateTeamMember({ ...members[index] });
    }
    if (validateAfterChange) {
      setTimeout(() => {
        form.validateFields();
      }, 10);
    }
    return shouldUpdateUser;
  };

  const handleUserSelect = (user, index, keepEmail, validateAfterChange) => {
    console.log('_Dasdas:', user, index, keepEmail, editInfo);
    // if (!user) {
    //   handleUniqueRole(index);
    //   handleRemove(fromRemove, editInfo.name, index)();
    // }
    return handleChange(user, index, keepEmail, validateAfterChange);
  };

  const onRoleChange = (value, index) => {
    const members = deepCopy(memberData);
    if (!members[index]) {
      members[index] = {};
    }
    members[index].permission = value;
    saveTeamsNames({ data: queryNamesResult, memberData: members });

    if (!createStep && members[index]?.email) {
      groupManip.updateTeamMember({ ...members[index] });
    }
  };

  const customRoleChange = (value, index) => {
    // console.log(value, index);
    const members = deepCopy(memberData);
    if (!members[index]) {
      members[index] = {};
    }
    members[index].role_name = value;
    saveTeamsNames({ data: queryNamesResult, memberData: members });

    if (!createStep && members[index]?.email) {
      groupManip.updateTeamMember({ ...members[index] });
    }
  };

  const renderRoleSelect = (index, field, remove) => (
    <Select
      dropdownClassName="role-select-dropdown"
      style={{ position: 'absolute' }}
      dropdownMatchSelectWidth={300}
      onChange={(value) => onRoleChange(value, index)}
      defaultActiveFirstOption={false}
      disabled={field.nonUS}
    >
      {field.nonUS
        ? projectRoleOptionForNonUs.map((i) => (
            <Option value={i.value} key={i.value}>
              <div className="role-name">{i.label}</div>
              <div className="role-description">{i.description}</div>
            </Option>
          ))
        : projectRoleOptions.map((i) => (
            <Option value={i.value} key={i.value}>
              <div className="role-name">{i.label}</div>
              <div className="role-description">{i.description}</div>
            </Option>
          ))}
    </Select>
  );

  const dropDownProps = (_index) => ({
    roleField: oldProjectRoleNames,
    currentRole: memberData[_index]?.role_name
      ? memberData[_index].role_name
      : null,
    customRoleChange,
  });

  const matchGroups = (_index) => {
    const formValues = form.getFieldsValue()?.teamMember;
    const _email = memberData[_index]?.email;
    const groupRelated = createStep ? groupData : getGroupData();
    const result = groupRelated
      ?.map((group) => {
        const _groupMembers = group.groupMembers.filter(
          (currentValue) => currentValue.people?.email === _email,
        );
        return _groupMembers.length > 0 ? group.groupInfo.groupName : null;
      })
      .filter((value) => value != null);
    if (formValues?.[_index]?.permission === projectRole.Contributor) {
      result.unshift('Project Admin');
    }
    return result;
  };

  const saveData = async (record) => {
    try {
      const res = await form.validateFields(['teamMember']);
      if (res.teamMember.some((item) => !item.email || !item.guid)) {
        alert.error('Please select a new user.');
        throw new Error('Please select a new user.');
      } else {
        setMemberOrClientChange(editInfo?.isNew ? 'add' : 'edit');
        setEditInfo(null);
      }
    } catch (err) {
      console.log('err: ', err);
      throw err;
    }
  };

  const deleteRow = (record, remove) => {
    const index = record.index;
    alert.confirm({
      content: (
        <>
          Are you sure you want to remove {record?.fullName}?
          <br />
          {matchGroups(index).map((group) => (
            <>
              · {group}
              <br />
            </>
          ))}
        </>
      ),
      okText: 'Remove',
      onOk: handleRemove(remove, record.name, index),
    });
  };

  // const renderItemFunc = (
  //   field,
  //   index,
  //   remove,
  //   showLastVisitAndCopyEmail = true,
  // ) => (
  //   <Form.Item key={field.key} noStyle>
  //     {/* 用style控制filter的方案-和懒加载结合使用也有bug */}
  //     {/* style={{ display: (filterNew ? field.isNew : true) ? 'flex' : 'none' }} */}
  //     <div className="form-wrapper change-height">
  //       <Form.Item
  //         {...field}
  //         // name="permission"
  //         className="client-column-item role-form-item"
  //         // fieldKey={[field.fieldKey, 'permission']}
  //         name={[field.name, 'permission']}
  //         initialValue={
  //           index > 2 ? projectRole['View-Only'] : projectRole.Contributor
  //         }
  //         key="permission"
  //       >
  //         {renderRoleSelect(index, field)}
  //       </Form.Item>
  //       <SelectPwcUserFormItem
  //         index={index}
  //         handleUserSelect={handleUserSelect}
  //         field={field}
  //         fieldName="email"
  //         guid={memberData?.[index]?.guid}
  //       />
  //       <Form.Item
  //         {...field}
  //         className="client-column-item name"
  //         key="fullName"
  //       >
  //         <span className="title-label name">
  //           {memberData[`${index}`]?.fullName}
  //         </span>
  //       </Form.Item>
  //       <Form.Item
  //         {...field}
  //         className="client-column-item role-custom"
  //         name={[field.name, 'role_name']}
  //         fieldKey={[field.fieldKey, 'role_name']}
  //         key="role_name"
  //       >
  //         <CustomRoleSelect
  //           index={index}
  //           customProps={dropDownProps(index)}
  //           uniqueRole={uniqueRole}
  //           setUniqueRole={setUniqueRole}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         {...field}
  //         className="client-column-item eu"
  //         name={[field.name, 'isEUBased']}
  //         fieldKey={[field.fieldKey, 'isEUBased']}
  //         valuePropName="checked"
  //         key="isEU"
  //       >
  //         <CuzCheckbox i={index} />
  //       </Form.Item>
  //       {isSettingPage ? (
  //         <Form.Item
  //           {...field}
  //           className="title-label last-visit"
  //           key="last-visit"
  //         >
  //           <span className="title-label last-visit">
  //             {' '}
  //             {showLastVisitAndCopyEmail && memberData[`${index}`]?.lastVisit}
  //           </span>
  //         </Form.Item>
  //       ) : (
  //         <div className="title-label last-visit" />
  //       )}
  //       <div className="title-label copy-email">
  //         {showLastVisitAndCopyEmail && (
  //           <span
  //             className="appkiticon icon-duplicate-outline a-font-24"
  //             onClick={() => {
  //               navigator.clipboard.writeText(memberData[index]?.email);
  //             }}
  //           />
  //         )}
  //       </div>
  //       <div className="title-label action">
  //         <a
  //           onClick={async () => {
  //             try {
  //               const res = await form.validateFields(['teamMember']);
  //               if (res.teamMember.some((item) => !item.email || !item.guid)) {
  //                 alert.error('Please select a new user.');
  //               } else {
  //                 setMemberOrClientChange(editInfo?.isNew ? 'add' : 'edit');
  //                 setEditInfo(null);
  //               }
  //             } catch (err) {
  //               console.log('err: ', err);
  //             }
  //           }}
  //         >
  //           {editInfo?.isNew ? 'Add' : 'Save'}
  //         </a>
  //         <a style={{ marginLeft: 16 }} onClick={() => cancelEditing()}>
  //           Cancel
  //         </a>
  //       </div>
  //     </div>
  //   </Form.Item>
  // );

  const copyAllEmails = () => {
    message.destroy();
    navigator.clipboard.writeText(
      memberData
        ?.filter((i) => i.email)
        .map((i) => i.email)
        .join(';'),
    );
    message.success('Email addresses copied!');
  };

  const isPreExistingUser = (member) => {
    return Boolean(member?.guid) && !member?.isNew;
  };

  const handleBulkAddConfirm = (validRows) => {
    const newMembers = validRows.map((row) => row.memberData);
    const members = [...deepCopy(memberData), ...newMembers];
    const membersWithIndex = members.map((item, index) => ({
      ...item,
      index,
    }));

    saveTeamsNames({ data: queryNamesResult, memberData: membersWithIndex });
    form.setFieldsValue({ teamMember: membersWithIndex });

    setDisabled((prev) => {
      const next = [...prev];
      newMembers.forEach((_, i) => {
        next[memberData.length + i] = false;
      });
      return next;
    });

    if (!createStep) {
      newMembers.forEach((member) => {
        groupManip.updateTeamMember({ ...member });
      });
    }

    setMemberOrClientChange('add');
    message.success(getBulkAddSuccessMessage(newMembers.length, createStep));
  };

  const bulkAddButton = (
    <BulkAddUsersButton
      disabled={Boolean(editInfo)}
      onClick={() => setBulkAddVisible(true)}
    />
  );

  return (
    <div>
      <Form form={form} name="createProject" autoComplete="off" {...layout}>
        <Form.List name="teamMember" {...layout} className="form-list">
          {(fields, { add, move, remove }) => {
            fromRemove = remove;
            return (
              <EditTableByRow
                dataKey="index"
                tableProps={{
                  columns: tableColumns({
                    projectRoleOptions,
                    editInfo,
                    setEditInfo,
                    memberData,
                    handleRemove,
                    remove,
                    matchGroups,
                    copyAllEmails,
                  }).map((item) => {
                    const field = memberData[editInfo?.index] || {};
                    return {
                      ...item,
                      customRender:
                        {
                          permission: renderRoleSelect(editInfo?.index, field),
                          email: (
                            <SelectPwcUserFormItem
                              index={editInfo?.index}
                              handleUserSelect={handleUserSelect}
                              field={field}
                              fieldName="email"
                              guid={field?.guid}
                              editInfo={editInfo}
                            />
                          ),
                          role_name: (
                            <CustomRoleSelect
                              index={editInfo?.index}
                              customProps={dropDownProps(editInfo?.index)}
                              uniqueRole={uniqueRole}
                              setUniqueRole={setUniqueRole}
                            />
                          ),
                          isEUBased: <CuzCheckbox i={editInfo?.index} />,
                        }[item.dataIndex] || null,
                    };
                  }),
                  dataSource:
                    memberData?.map?.((item, index) => {
                      // 默认值在这里加
                      const resData = {
                        // permission:
                        //   index > 2
                        //     ? projectRole['View-Only']
                        //     : projectRole.Contributor,
                        ...(item || {}),
                        index,
                        isExistingUser: isPreExistingUser(item),
                      };
                      return resData;
                    }) || [],
                  pagination: false,
                }}
                showAddNewBtn={!editInfo}
                setEditInfo={(editInfo) => setEditInfo(editInfo)}
                handleAdd={handleAdd}
                deleteRow={(record) => deleteRow(record, remove)}
                saveRow={saveData}
                cancelRow={cancelEditing}
                extraActions={bulkAddButton}
              />
            );
          }}
        </Form.List>

        {renderAction && renderAction()}
      </Form>
      <BulkAddUsersModal
        visible={bulkAddVisible}
        teamType="pwc"
        createStep={createStep}
        existingUsers={memberData}
        onConfirm={handleBulkAddConfirm}
        onCancel={() => setBulkAddVisible(false)}
      />
    </div>
  );
};

const mapStateToProps = ({ projects, login }) => ({
  teamsData: projects.teamsData || {},
  groupData: projects.groupData,
  queryNamesResult: projects.queryNamesResult || [],
  memberData: projects.memberData,
  operatorName: `${login.userInfo.given_name} ${login.userInfo.family_name}`,
  userInfo: login.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
  changeTeamsNames(data) {
    dispatch(action.changeTeamsNames(data));
  },
  saveTeamsNames(data) {
    dispatch(action.saveTeamsNames(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(forwardRef(TeamForm));
